import GoogleIcon from "@assets/icons/google.svg?react";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import viewportState from "@src/app/stores/viewport";
import dayjs from "dayjs";
// import type { BFFArticleBodyElement } from "@src/app/types/bff";
import { useSnapshot } from "valtio";

import Button from "../Button/Button";
import CategoryTag from "../CategoryTag";
import DescriptionTag from "../DescriptionTag";
import Link from "../Link";
import SocialShare from "../SocialShare/SocialShare";

export default function ArticleHeaderSection() {
  const { article } = useRouteResponse("articlePage");
  const { created = "", sectionName, section } = article || {};

  const formattedPublishDate = created
    ? dayjs(created).format("D MMM YYYY")
    : "";

  const { isDesktopView } = useSnapshot(viewportState);

  const descriptionTag =
    article?.displayType === "big_read"
      ? "BigRead"
      : article?.displayType === "photo_story"
        ? "PhotoStory"
        : undefined;

  return (
    <div className="dark:text-primary-on-dark mx-3 mb-8 lg:mb-4">
      {descriptionTag ? (
        <div className="hidden pt-4 lg:block">
          <DescriptionTag name={descriptionTag} />
        </div>
      ) : null}

      {/* Header */}
      <h1 className="text-header-2 lg:text-header-1 my-4">
        {article?.title || ""}
      </h1>

      {/* Standfirst */}
      {article?.standfirst && (
        <p className="text-header-4 border-divider-secondary dark:border-divider-secondary-on-dark mb-4 border-t border-b py-4">
          {article.standfirst || ""}
        </p>
      )}

      <div className="flex justify-between">
        <div className="flex items-center gap-3">
          {/* Date & Category Tag  */}
          <p className="text-secondary dark:text-secondary-on-dark text-label-2 font-bold">
            {formattedPublishDate}
          </p>

          <CategoryTag name={sectionName} href={`/${section}`} />
        </div>

        <div className="flex items-center gap-3">
          <Button
            variant="tertiary"
            size="medium"
            icon={<GoogleIcon />}
            iconPosition="left"
            className="hidden h-8 lg:flex"
          >
            <Link to="https://www.google.com/preferences/source?q=https://www.thinkchina.sg">
              Add ThinkChina as a preferred source
            </Link>
          </Button>

          <SocialShare viewType={isDesktopView ? "inline" : "dropdown"} />
        </div>
      </div>

      <Button
        variant="tertiary"
        size="medium"
        icon={<GoogleIcon />}
        iconPosition="left"
        className="mt-2 flex h-8 lg:hidden"
      >
        <Link to="https://www.google.com/preferences/source?q=https://www.thinkchina.sg">
          Add ThinkChina as a preferred source
        </Link>
      </Button>
    </div>
  );
}
